// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { FiTrash2, FiChevronDown, FiSearch, FiX, FiPlusCircle, FiList, FiCheckCircle, FiInfo } from 'react-icons/fi';
// import { toast } from 'react-toastify';

// // DHYAN DEIN: Apne actual API service ka path yahan zaroor check karein
// import { getTeamMembers, getShippingLineList, addShipment, postContainerInfo } from '../../ApiController/ApiService'; 
import ExportBookingWizard from './ExportBookingWizard';

// export default function CreateContainerModal({
//   formData,
//   setFormData,
//   handleInputChange,
//   handleContainerChange,
//   // addContainerRow aur removeContainerRow ki ab zaroorat nahi kyunki single container hai
//   onClose,
//   onSuccess, // Parent ko batane ke liye ki API call success ho gayi
//   openFTL,
//   openLTL,
//   openMap
// }) {
//   const { t } = useTranslation();

//   // --- Queue State for Multiple Shipments ---
//   const [shipmentQueue, setShipmentQueue] = useState([]);

//   // --- Local UI State ---
//   const [selectedTab, setSelectedTab] = useState('Import');
//   const [showDropdowns, setShowDropdowns] = useState(false);
//   const [search, setSearch] = useState('');
//   const [selectedDriver, setSelectedDriver] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false); 
  
//   // --- Local API State ---
//   const [drivers, setDrivers] = useState([]);
//   const [filteredDrivers, setFilteredDrivers] = useState([]);
//   const [loadingDrivers, setLoadingDrivers] = useState(false);
//   const [driverError, setDriverError] = useState('');
//   const [shippingLines, setShippingLines] = useState([]);

//   // Fetch Drivers
//   useEffect(() => {
//     const fetchDrivers = async () => {
//       setLoadingDrivers(true);
//       setDriverError('');
//       try {
//         const rawDrivers = await getTeamMembers();
//         if (!Array.isArray(rawDrivers)) {
//           throw new Error(t('errors.unexpectedApiResponse') || 'Unexpected API Response');
//         }
//         const formattedDrivers = rawDrivers
//           .filter((member) => member.userType?.toLowerCase() === 'driver')
//           .map((member) => ({
//             id: member._id,
//             name: member.fullName || t('orders.unnamedDriver', 'Unnamed Driver'),
//             avatar: member.image || 'https://api.dicebear.com/7.x/avataaars/svg?seed=fallback',
//           }));
          
//         if (formattedDrivers.length === 0) {
//           setDriverError(t('errors.noDriversFound') || 'No drivers found');
//         } else {
//           setDrivers(formattedDrivers);
//           setFilteredDrivers(formattedDrivers);
//         }
//       } catch (err) {
//         setDriverError(t('errors.fetchDriversFailed', { message: err.message }));
//       } finally {
//         setLoadingDrivers(false);
//       }
//     };
//     fetchDrivers();
//   }, [t]);

//   // Fetch Shipping Lines
//   useEffect(() => {
//     const fetchShippingLines = async () => {
//       try {
//         const lines = await getShippingLineList();
//         setShippingLines(lines || []);
//       } catch (error) {
//         console.error("Error fetching shipping lines:", error);
//       }
//     };
//     fetchShippingLines();
//   }, []);

//   // Filter Drivers based on search
//   useEffect(() => {
//     setFilteredDrivers(
//       drivers.filter(
//         (driver) =>
//           driver.name.toLowerCase().includes(search.toLowerCase()) ||
//           driver.id.includes(search)
//       )
//     );
//   }, [search, drivers]);

//   // Handle adding intermediate stops locally
//   const addIntermediateStop = () => {
//     setFormData({
//       ...formData,
//       intermediateDestinations: [
//         ...(formData.intermediateDestinations || []), 
//         { destination: '', time: '', lat: '', lng: '' }
//       ],
//     });
//   };

//   // Helper function to reset form
//   const resetForm = () => {
//     setFormData({
//       orderId: '', sl: '', origin: '', destination: '', description: '', goodsType: '',
//       pickUpDate: '', dropOffDate: '', pickUpHours: '', dropOffHours: '',
//       length: '', commodity: '', terminal: '', routeNotes: '', driverContactNumber: '', vehicleNumber: '',
//       addOnDate: '', estimateDeliveryDate: '', portName: '', ticketNumber: '', bookingNumber: '', price: '', status: '',
//       originLat: '', originLng: '', destinationLat: '', destinationLng: '',
//       importExportType: formData.importExportType || 'import',
//       // Resetting to exactly one empty container
//       containers: [{ containerNumber: '', containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: '' }],
//       intermediateDestinations: []
//     });
//     setSelectedDriver(null);
//   };

//   // ==========================================
//   // VALIDATION LOGIC
//   // ==========================================
//   const validateForm = (data) => {
//     const requiredFields = [
//       'orderId', 'origin', 'destination', 
//       'goodsType', 'pickUpDate', 'dropOffDate', 'addOnDate', 'estimateDeliveryDate', 'status'
//     ];

//     for (const field of requiredFields) {
//       if (!data[field]) {
//         toast.error(`${t('orders.' + field, field)} Required`, { position: "top-right" });
//         return false;
//       }
//     }

//     // --- Container Validation (Strictly 1 Container: 4 Letters + 7 Numbers) ---
//     const containerNum = data.containers?.[0]?.containerNumber;
//     const containerRegex = /^[A-Za-z]{4}\d{7}$/;

//     if (!containerNum) {
//       toast.error(`${t('orders.containerNumber', 'Container Number')} Required`, { position: "top-right" });
//       return false;
//     }

//     if (!containerRegex.test(containerNum)) {
//       toast.error("Container Number must be 4 letters followed by 7 numbers (e.g., ABCD1234567)", { position: "top-right" });
//       return false;
//     }

//     // --- Coordinates Validation ---
//     const isValidLatitude = (val) => { const n = parseFloat(val); return !isNaN(n) && n >= -90 && n <= 90; };
//     const isValidLongitude = (val) => { const n = parseFloat(val); return !isNaN(n) && n >= -180 && n <= 180; };

//     if (data.originLat && data.originLng) {
//       if (!isValidLatitude(data.originLat) || !isValidLongitude(data.originLng)) {
//         toast.error(t('errors.invalidCoordinates', { field: 'Origin' }), { position: "top-right" });
//         return false;
//       }
//     }

//     return true;
//   };

//   // ==========================================
//   // ADD TO LIST (QUEUE)
//   // ==========================================
//   const handleAddToList = () => {
//     if (!validateForm(formData)) return;
    
//     const validatedIntermediateDestinations = (formData.intermediateDestinations || []).map((stop, index) => {
//       if (stop.destination === '' && stop.time === '' && formData.intermediateDestinations.length === 1) return null;
//       if (!stop.destination || !stop.time) {
//         toast.error(`Intermediate Stop ${index + 1} is incomplete`, { position: "top-right" });
//         return false;
//       }
//       return stop;
//     });

//     if (validatedIntermediateDestinations.includes(false)) return;

//     setShipmentQueue([...shipmentQueue, { ...formData }]);
//     toast.success(`Shipment added to list! Fill form for next.`, { position: "top-right" });
//     resetForm();
//   };

//   const removeFromQueue = (index) => {
//     const newQueue = [...shipmentQueue];
//     newQueue.splice(index, 1);
//     setShipmentQueue(newQueue);
//   };

//   // ==========================================
//   // SUBMIT ALL API LOGIC
//   // ==========================================
//   const handleFinalSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       let finalQueue = [...shipmentQueue];
      
//       // Save current form to queue if filled
//       if (formData.orderId || formData.origin) {
//         if (!validateForm(formData)) return;
//         finalQueue.push({ ...formData });
//       }

//       if (finalQueue.length === 0) {
//         toast.error("Please fill the details or add to list first!", { position: "top-right" });
//         return;
//       }

//       setIsSubmitting(true);

//       const addShipmentPromises = [];
//       const containerDataToPost = []; 

//       for (const shipmentData of finalQueue) {
//         // Shipping line name
//         const selectedSlObj = shippingLines.find(line => (line._id || line.id || line.name || line) === shipmentData.sl);
//         const shippingLineName = selectedSlObj ? (selectedSlObj.name || selectedSlObj) : shipmentData.sl;

//         const validatedIntermediateDestinations = (shipmentData.intermediateDestinations || [])
//           .filter(stop => stop.destination && stop.time)
//           .map(stop => ({
//             destination: stop.destination,
//             time: stop.time,
//             coordinates: (stop.lng && stop.lat) ? {
//               type: 'Point',
//               coordinates: [parseFloat(stop.lng), parseFloat(stop.lat)]
//             } : undefined
//           }));

//         // Since we only have 1 container now, we still loop through the array of 1
//         shipmentData.containers.forEach((container) => {
//           const submissionData = {
//             ...shipmentData,
//             containerNumber: container.containerNumber,
//             containerType: container.containerType,
//             sealNumber: container.sealNumber,
//             weight: container.weight,
//             noOfPallets: container.noOfPallets,
//             containerComments: container.containerComments,
            
//             currentLocation: (shipmentData.originLng && shipmentData.originLat) 
//               ? { type: 'Point', coordinates: [parseFloat(shipmentData.originLng), parseFloat(shipmentData.originLat)] } 
//               : undefined,
              
//             destinationLocation: (shipmentData.destinationLng && shipmentData.destinationLat) 
//               ? { type: 'Point', coordinates: [parseFloat(shipmentData.destinationLng), parseFloat(shipmentData.destinationLat)] } 
//               : undefined,
              
//             intermediateDestinations: validatedIntermediateDestinations.length > 0 ? validatedIntermediateDestinations : undefined,
            
//             containers: undefined // Remove array from payload
//           };

//           // 1. Queue Main API
//           addShipmentPromises.push(addShipment(submissionData));

//           // 2. Queue Container Data (Post baad mein karenge)
//           if (container.containerNumber && shippingLineName) {
//             containerDataToPost.push({
//               containerNumber: container.containerNumber,
//               shippingLine: shippingLineName
//             });
//           }
//         });
//       }

//       // ------------------------------------------------------------------
//       // STEP 1: PEHLE ADD HOGA (Main Shipment Creation)
//       // ------------------------------------------------------------------
//       const res = await Promise.all(addShipmentPromises);
//       console.log('Main Shipment Response:', res); 

//       const allSuccessful = res.every(response => response?.status === 200 || response?.status === 201);

//       if (allSuccessful) {
        
//         // ------------------------------------------------------------------
//         // STEP 2: FIR POST HOGA (Container Post)
//         // ------------------------------------------------------------------
//         if (containerDataToPost.length > 0) {
//           const postPromises = containerDataToPost.map(payload => 
//             postContainerInfo(payload).catch(err => console.error("Container post failed:", err))
//           );
//           await Promise.all(postPromises);
//         }

//         const generatedIds = res
//           .map(r => r?.data?.Id)
//           .filter(Boolean)
//           .join(', ');

//         toast.success(
//           `Successfully created ${res.length} Shipment(s)! IDs: ${generatedIds}`, 
//           { position: "top-right", autoClose: 5000 }
//         );

//         setShipmentQueue([]);
//         resetForm();

//         if (onSuccess) onSuccess();
//         if (onClose) onClose(); 

//       } else {
//         toast.warning("Some shipments failed to create. Please check the console logs.", { position: "top-right" });
//       }

//     } catch (err) {
//       toast.error(err.message || 'Failed to create shipment(s)', { position: "top-right" });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
//       <div
//         className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-full max-w-[900px] max-h-[90vh] overflow-y-auto custom-scrollbar flex flex-col md:flex-row gap-6"
//         style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
//       >
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-2xl text-gray-300 hover:text-white transition z-10"
//         >
//           <FiX />
//         </button>

//         {/* --- MAIN FORM SECTION (Left Side) --- */}
//         <div className="flex-1">
//           <h2 className="text-xl sm:text-2xl font-bold mb-6">
//             {t('orders.createNewContainer')}
//           </h2>

//           {/* --- Tabs --- */}
//           <div className="flex justify-center mb-6">
//             <div className="bg-[#151b40] p-1 border border-[#2A2A4D] rounded-full flex w-full max-w-[450px] overflow-x-auto custom-scrollbar">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setSelectedTab('Import');
//                   setFormData({ ...formData, importExportType: 'import' });
//                 }}
//                 className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Import' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
//               >
//                 {t('orders.import')}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setSelectedTab('Export');
//                   setFormData({ ...formData, importExportType: 'export' });
//                 }}
//                 className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Export' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
//               >
//                 {t('orders.export')}
//               </button>
//               <button
//                 type="button"
//                 onClick={() => {
//                   setSelectedTab('Dispatch');
//                   setFormData({ ...formData, importExportType: 'Disptach' });
//                 }}
//                 className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Dispatch' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
//               >
//                 {t('Dispatch')}
//               </button>
//               <button
//                 type="button"
//                 onClick={openFTL}
//                 className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'FTL' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
//               >
//                 {t('FTL')}
//               </button>
//               <button
//                 type="button"
//                 onClick={openLTL}
//                 className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'LTL' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
//               >
//                 {t('LTL')}
//               </button>
//             </div>
//           </div>

//           {/* --- Form --- */}
//           <form className="space-y-4" onSubmit={handleFinalSubmit}>
            
//             {/* Order ID */}
//             <div>
//               <label className="text-sm block mb-1 text-gray-300">{t('orders.orderId')}</label>
//               <input
//                 className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none focus:ring-2 focus:ring-[#6F1AFF]"
//                 value={formData.orderId}
//                 onChange={(e) => handleInputChange(e, 'orderId')}
//                 placeholder={t('orders.orderIdPlaceholder')}
//               />
//             </div>

//             <h3 className="text-sm text-cyan-400 font-semibold mt-4 border-b border-[#2A2A4D] pb-1">
//               {t('orders.shippingLine')}
//             </h3>
            
//             <div>
//               <label className="text-sm block mb-1 text-gray-300">{t('orders.selectShippingLine')}</label>
//               <select
//                 className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                 value={formData.sl}
//                 onChange={(e) => handleInputChange(e, 'sl')}
//               >
//                 <option value="">{t('orders.selectShippingLine')}</option>
//                 {shippingLines.map((line, index) => (
//                   <option key={index} value={line._id || line.id || line.name || line}>
//                     {line.name || line}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Locations */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.origin')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none mb-2"
//                   value={formData.origin}
//                   onChange={(e) => handleInputChange(e, 'origin')}
//                   placeholder={t('orders.originPlaceholder')}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => openMap('origin')}
//                   className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90 transition"
//                 >
//                   {t('orders.selectOnMap')}
//                 </button>
//                 {formData.originLat && formData.originLng && (
//                   <div className="text-xs text-gray-400 mt-1">
//                     {formData.originLat}, {formData.originLng}
//                   </div>
//                 )}
//               </div>
              
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.destination')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none mb-2"
//                   value={formData.destination}
//                   onChange={(e) => handleInputChange(e, 'destination')}
//                   placeholder={t('orders.destinationPlaceholder')}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => openMap('destination')}
//                   className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90 transition"
//                 >
//                   {t('orders.selectOnMap')}
//                 </button>
//                 {formData.destinationLat && formData.destinationLng && (
//                   <div className="text-xs text-gray-400 mt-1">
//                     {formData.destinationLat}, {formData.destinationLng}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Goods details */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.goodsDescription')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.description}
//                   onChange={(e) => handleInputChange(e, 'description')}
//                   placeholder={t('orders.goodsDescriptionPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.goodsType')}</label>
//                 <select
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.goodsType}
//                   onChange={(e) => handleInputChange(e, 'goodsType')}
//                 >
//                   <option value="">{t('orders.selectGoodsType')}</option>
//                   <option value="Electronics">{t('orders.goodsTypeOptions.electronics')}</option>
//                   <option value="Textile">{t('orders.goodsTypeOptions.textile')}</option>
//                   <option value="Food">{t('orders.goodsTypeOptions.food')}</option>
//                 </select>
//               </div>
//             </div>

//             {/* Times */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.pickUpDateTime')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="datetime-local"
//                   value={formData.pickUpDate}
//                   min={new Date().toISOString().slice(0, 16)}
//                   onChange={(e) => handleInputChange(e, 'pickUpDate')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.dropOffDateTime')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="datetime-local"
//                   value={formData.dropOffDate}
//                   min={new Date().toISOString().slice(0, 16)}
//                   onChange={(e) => handleInputChange(e, 'dropOffDate')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.pickUpHours')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.pickUpHours}
//                   onChange={(e) => handleInputChange(e, 'pickUpHours')}
//                   placeholder={t('orders.pickUpHoursPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.dropOffHours')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.dropOffHours}
//                   onChange={(e) => handleInputChange(e, 'dropOffHours')}
//                   placeholder={t('orders.dropOffHoursPlaceholder')}
//                 />
//               </div>
//             </div>

//             {/* --- SINGLE CONTAINER DETAILS SECTION --- */}
//             <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
//               {t('orders.containerDetails')}
//             </h3>

//             <div className="p-4 border border-[#2A2A4D] rounded-lg bg-[#101533]">
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.containerNumber')}</label>
//                   <input
//                     name="containerNumber"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none uppercase"
//                     value={formData.containers[0]?.containerNumber || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder="ABCD1234567"
//                     maxLength={11}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.containerType')}</label>
//                   <input
//                     name="containerType"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
//                     value={formData.containers[0]?.containerType || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder={t('orders.containerTypePlaceholder')}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.sealNumber')}</label>
//                   <input
//                     name="sealNumber"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
//                     value={formData.containers[0]?.sealNumber || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder={t('orders.sealNumber')}
//                   />
//                 </div>
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.noOfPallets')}</label>
//                   <input
//                     name="noOfPallets"
//                     type="number"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
//                     value={formData.containers[0]?.noOfPallets || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder="0"
//                   />
//                 </div>
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.weight')}</label>
//                   <input
//                     name="weight"
//                     type="number"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
//                     value={formData.containers[0]?.weight || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder="0"
//                   />
//                 </div>
//                 <div>
//                   <label className="text-xs block mb-1 text-gray-400">{t('orders.containerComments')}</label>
//                   <input
//                     name="containerComments"
//                     className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
//                     value={formData.containers[0]?.containerComments || ''}
//                     onChange={(e) => handleContainerChange(e, 0)}
//                     placeholder="Any notes..."
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* validation note  */}
//             <div className="flex gap-3 text-[11px] sm:text-xs text-cyan-100 bg-cyan-900/30 p-3 rounded-lg border border-cyan-800/50 leading-relaxed mt-2">
//               <FiInfo className="text-cyan-400 shrink-0 mt-0.5" size={16} />
//               <p>
//                 <span className="font-semibold text-cyan-400">ShipsGo Validation: </span> 
//                 Validates container numbers (4 letters + 7 numbers) by integrating with carrier databases to provide real-time status, location, and tracking via a user-friendly dashboard. Users can track, verify, and receive automated alerts for shipments using container numbers, booking numbers, or bill of lading numbers, with options for manual entry, Excel upload, or API integration.
//               </p>
//             </div>

//             {/* Misc details */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.length')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.length}
//                   onChange={(e) => handleInputChange(e, 'length')}
//                   placeholder={t('orders.lengthPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.commodity')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.commodity}
//                   onChange={(e) => handleInputChange(e, 'commodity')}
//                   placeholder={t('orders.commodityPlaceholder')}
//                 />
//               </div>
//             </div>

//             {/* Route Info */}
//             <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
//               {t('orders.routeDeliveryInfo')}
//             </h3>
            
//             {(formData.intermediateDestinations || []).map((stop, index) => (
//               <div key={index} className="space-y-2 border-l-2 border-[#6F1AFF] pl-4 mb-4 bg-[#101533] p-3 rounded-r-lg">
//                 <label className="text-sm block font-semibold text-cyan-300">
//                   {t('orders.intermediateStop')} #{index + 1}
//                 </label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={stop.destination}
//                   onChange={(e) => handleInputChange(e, 'destination', index)}
//                   placeholder={t('orders.intermediateStopPlaceholder')}
//                 />
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="datetime-local"
//                   value={stop.time}
//                   onChange={(e) => handleInputChange(e, 'time', index)}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => openMap('intermediate', index)}
//                   className="w-full py-2 bg-[#1D2A85] text-white rounded-md text-sm hover:bg-[#2A3AA5] transition"
//                 >
//                   {t('orders.selectOnMap')}
//                 </button>
//                 {stop.lat && stop.lng && (
//                   <div className="text-xs text-gray-400 mt-1">
//                     {stop.lat}, {stop.lng}
//                   </div>
//                 )}
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={addIntermediateStop}
//               className="text-cyan-400 text-sm font-semibold hover:underline"
//             >
//               + {t('orders.addIntermediateStop')}
//             </button>

//             <div>
//               <label className="text-sm block mb-1 text-gray-300">{t('orders.terminal')}</label>
//               <input
//                 className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                 value={formData.terminal}
//                 onChange={(e) => handleInputChange(e, 'terminal')}
//                 placeholder={t('orders.terminalPlaceholder')}
//               />
//             </div>
//             <div>
//               <label className="text-sm block mb-1 text-gray-300">{t('orders.routeNotes')}</label>
//               <textarea
//                 rows="3"
//                 className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                 value={formData.routeNotes}
//                 onChange={(e) => handleInputChange(e, 'routeNotes')}
//                 placeholder={t('orders.routeNotesPlaceholder')}
//               />
//             </div>

//             {/* Driver Assignment */}
//             <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
//               {t('orders.driverAssignment')}
//             </h3>
//             <div className="relative">
//               <label className="text-sm block mb-1 text-gray-300">{t('orders.assignedDriver')}</label>
//               <div
//                 className="w-full px-3 py-2 rounded bg-white text-black flex justify-between items-center cursor-pointer text-sm outline-none focus:ring-2 focus:ring-[#6F1AFF]"
//                 onClick={() => setShowDropdowns(!showDropdowns)}
//               >
//                 {selectedDriver ? (
//                   <div className="flex items-center gap-2">
//                     <img src={selectedDriver.avatar} alt="Driver" className="w-6 h-6 rounded-full" />
//                     <span className="font-medium">{selectedDriver.name}</span>
//                   </div>
//                 ) : (
//                   <span className="text-gray-500">{t('orders.selectDriver')}</span>
//                 )}
//                 <FiChevronDown className="text-lg text-gray-500" />
//               </div>

//               {showDropdowns && (
//                 <div className="absolute z-10 mt-1 w-full bg-white shadow-xl rounded-md p-2 border border-gray-200">
//                   <div className="relative mb-2">
//                     <input
//                       type="text"
//                       placeholder={t('orders.searchDriverPlaceholder')}
//                       className="w-full pl-9 pr-3 py-2 bg-gray-100 text-black rounded text-sm outline-none"
//                       value={search}
//                       onChange={(e) => setSearch(e.target.value)}
//                     />
//                     <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//                   </div>
//                   <div className="max-h-48 overflow-y-auto custom-scrollbar">
//                     {loadingDrivers ? (
//                       <div className="text-gray-500 text-sm text-center py-4">{t('orders.loadingDrivers')}</div>
//                     ) : driverError ? (
//                        <div className="text-red-500 text-sm text-center py-4">{driverError}</div>
//                     ) : filteredDrivers.length === 0 ? (
//                       <div className="text-gray-500 text-sm text-center py-4">{t('orders.noDriverFound')}</div>
//                     ) : (
//                       filteredDrivers.map((driver) => (
//                         <div
//                           key={driver.id}
//                           className="flex items-center gap-3 p-2 hover:bg-violet-50 rounded cursor-pointer transition-colors"
//                           onClick={() => {
//                             setSelectedDriver(driver);
//                             setFormData({
//                               ...formData,
//                               driverId: driver.id,
//                               driverContactNumber: '',
//                               vehicleNumber: '',
//                             });
//                             setShowDropdowns(false);
//                           }}
//                         >
//                           <img src={driver.avatar} alt="Avatar" className="w-8 h-8 rounded-full border border-gray-200" />
//                           <span className="text-black text-sm font-medium">{driver.name}</span>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.vehicleNumber')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.vehicleNumber}
//                   onChange={(e) => handleInputChange(e, 'vehicleNumber')}
//                   placeholder={t('orders.vehicleNumberPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.driverContact')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.driverContactNumber}
//                   onChange={(e) => handleInputChange(e, 'driverContactNumber')}
//                   placeholder={t('orders.driverContactPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.addedOn')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="datetime-local"
//                   value={formData.addOnDate}
//                   min={new Date().toISOString().slice(0, 16)}
//                   onChange={(e) => handleInputChange(e, 'addOnDate')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.estimatedDeliveryDate')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="datetime-local"
//                   value={formData.estimateDeliveryDate}
//                   min={new Date().toISOString().slice(0, 16)}
//                   onChange={(e) => handleInputChange(e, 'estimateDeliveryDate')}
//                 />
//               </div>
//             </div>

//             {/* Port Details */}
//             <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
//               {t('orders.portDetails')}
//             </h3>
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.portName')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.portName}
//                   onChange={(e) => handleInputChange(e, 'portName')}
//                   placeholder={t('orders.portNamePlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.ticketNumber')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.ticketNumber}
//                   onChange={(e) => handleInputChange(e, 'ticketNumber')}
//                   placeholder={t('orders.ticketNumberPlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.bookingNumber')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.bookingNumber}
//                   onChange={(e) => handleInputChange(e, 'bookingNumber')}
//                   placeholder={t('orders.bookingNumberPlaceholder')}
//                 />
//               </div>
//             </div>

//             <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
//               {t('orders.pricelabel')}
//             </h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.price')}</label>
//                 <input
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   type="number"
//                   value={formData.price}
//                   onChange={(e) => handleInputChange(e, 'price')}
//                   placeholder={t('orders.pricePlaceholder')}
//                 />
//               </div>
//               <div>
//                 <label className="text-sm block mb-1 text-gray-300">{t('orders.statusLabel')}</label>
//                 <select
//                   className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
//                   value={formData.status}
//                   onChange={(e) => handleInputChange(e, 'status')}
//                 >
//                   <option value="">{t('orders.selectStatus')}</option>
//                   <option value="Pending">{t('orders.status.pending')}</option>
//                   <option value="In Transit">{t('orders.status.inTransit')}</option>
//                   <option value="Delivered">{t('orders.status.delivered')}</option>
//                 </select>
//               </div>
//             </div>

//             {/* ACTION BUTTONS */}
//             <div className="flex flex-col sm:flex-row gap-3 mt-8">
              
//               {/* Button 1: Add to List & Clear Data */}
//               <button
//                 type="button"
//                 onClick={handleAddToList}
//                 className="flex-1 py-3 border border-cyan-400 text-cyan-400 rounded-xl font-bold hover:bg-cyan-400/10 transition-all flex justify-center items-center gap-2"
//               >
//                 <FiPlusCircle /> Add to List & New
//               </button>

//               {/* Button 2: Submit API Call */}
//               <button
//                 type="submit"
//                 disabled={isSubmitting || loadingDrivers}
//                 className="flex-1 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white py-3 rounded-xl font-bold hover:opacity-90 shadow-lg transition-all flex justify-center items-center"
//               >
//                 {isSubmitting ? (
//                   <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                 ) : (
//                   shipmentQueue.length > 0 
//                   ? `Submit All (${shipmentQueue.length + (formData.orderId ? 1 : 0)})` 
//                   : 'Submit Single'
//                 )}
//               </button>
//             </div>

//           </form>
//         </div>

//         {/* --- QUEUE SIDEBAR (Right Side) --- */}
//         {shipmentQueue.length > 0 && (
//           <div className="w-full md:w-[280px] bg-white/5 p-4 rounded-xl border border-white/10 h-fit sticky top-0">
//             <h3 className="text-cyan-400 font-bold flex items-center gap-2 mb-4 border-b border-white/10 pb-2">
//               <FiList /> Queued Shipments ({shipmentQueue.length})
//             </h3>
            
//             <div className="space-y-3 max-h-[400px] overflow-y-auto custom-scrollbar pr-1">
//               {shipmentQueue.map((item, index) => (
//                 <div key={index} className="bg-[#101533] p-3 rounded-lg border border-[#2A2A4D] relative group hover:border-cyan-500 transition-colors">
//                   <button 
//                     onClick={() => removeFromQueue(index)}
//                     className="absolute top-2 right-2 text-gray-500 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-opacity bg-[#101533] rounded-full p-1"
//                   >
//                     <FiTrash2 size={16} />
//                   </button>
//                   <p className="text-sm font-bold text-white flex items-center gap-1">
//                     <FiCheckCircle className="text-green-400" size={14}/> {item.orderId}
//                   </p>
//                   <div className="text-xs text-gray-400 mt-2 space-y-1">
//                     <p><span className="text-gray-500">From:</span> {item.origin}</p>
//                     <p><span className="text-gray-500">To:</span> {item.destination}</p>
//                     <p><span className="text-gray-500">Containers:</span> {item.containers[0]?.containerNumber || 'N/A'}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <p className="text-[11px] text-gray-400 mt-4 italic text-center">
//               Click "Submit All" to create these shipments.
//             </p>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FiTrash2, FiSearch, FiX, FiPlusCircle, FiList, FiCheckCircle, FiInfo, FiCopy } from 'react-icons/fi';
import { toast } from 'react-toastify';


import { getShippingLineList, addShipment, postContainerInfo, getPorts } from '../../ApiController/ApiService'; 

export default function CreateContainerModal({
  formData,
  setFormData,
  handleInputChange,
  onClose,
  onSuccess,
  openFTL,
  openLTL,
  openMap,
  fetchShipments,
  initialTab = 'Import'
}) {
  const { t } = useTranslation();

  // --- Queue State for Multiple Shipments ---
  const [shipmentQueue, setShipmentQueue] = useState([]);

  // --- Local UI State ---
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [formErrors, setFormErrors] = useState({});
  
  // --- Autocomplete State ---
  const [originSuggestions, setOriginSuggestions] = useState([]);
  const [destinationSuggestions, setDestinationSuggestions] = useState([]);
  const [isSearchingOrigin, setIsSearchingOrigin] = useState(false);
  const [isSearchingDestination, setIsSearchingDestination] = useState(false);
  
  const [activeIntermediateIndex, setActiveIntermediateIndex] = useState(null);
  const [intermediateSuggestions, setIntermediateSuggestions] = useState([]);
  const [isSearchingIntermediate, setIsSearchingIntermediate] = useState(false);
  
  // --- Port Autocomplete State ---
  const [isPortDropdownOpen, setIsPortDropdownOpen] = useState(false);
  const [portSearchInput, setPortSearchInput] = useState('');
  const [portSuggestions, setPortSuggestions] = useState([]);
  const [isSearchingPort, setIsSearchingPort] = useState(false);
  
  // --- Bulk Container State ---
  const [bulkContainers, setBulkContainers] = useState('');
        
  // --- Local API State ---  
  const [shippingLines, setShippingLines] = useState([]);

  // Fetch Ports Autocomplete
  useEffect(() => {
    if (!isPortDropdownOpen) return;
    const delayDebounceFn = setTimeout(async () => {
      setIsSearchingPort(true);
      try {
        const data = await getPorts('', portSearchInput);
        let portsArray = Array.isArray(data) ? data : data.data || [];
        setPortSuggestions(portsArray);
      } catch (error) {
        setPortSuggestions([]);
      } finally {
        setIsSearchingPort(false);
      }
    }, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [portSearchInput, isPortDropdownOpen]);

  // Fetch Shipping Lines
  useEffect(() => {
    const fetchShippingLines = async () => {
      try {
        const lines = await getShippingLineList();
        setShippingLines(lines || []);
      } catch (error) {
        console.error("Error fetching shipping lines:", error);
      }
    };
    fetchShippingLines();
  }, []);

  // --- Autocomplete Effects ---
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (formData.origin && formData.origin.trim().length > 2 && !formData.originLat) {
        setIsSearchingOrigin(true);
        try {
          const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(formData.origin)}&limit=5`);
          const data = await response.json();
          setOriginSuggestions(data || []);
        } catch (error) {
          setOriginSuggestions([]);
        } finally {
          setIsSearchingOrigin(false);
        }
      } else {
        setOriginSuggestions([]);
      }
    }, 600);
    return () => clearTimeout(delayDebounceFn);
  }, [formData.origin, formData.originLat]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (formData.destination && formData.destination.trim().length > 2 && !formData.destinationLat) {
        setIsSearchingDestination(true);
        try {
          const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(formData.destination)}&limit=5`);
          const data = await response.json();
          setDestinationSuggestions(data || []);
        } catch (error) {
          setDestinationSuggestions([]);
        } finally {
          setIsSearchingDestination(false);
        }
      } else {
        setDestinationSuggestions([]);
      }
    }, 600);
    return () => clearTimeout(delayDebounceFn);
  }, [formData.destination, formData.destinationLat]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (activeIntermediateIndex !== null) {
        const query = formData.intermediateDestinations?.[activeIntermediateIndex]?.destination;
        const lat = formData.intermediateDestinations?.[activeIntermediateIndex]?.lat;
        if (query && query.trim().length > 2 && !lat) {
          setIsSearchingIntermediate(true);
          try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`);
            const data = await response.json();
            setIntermediateSuggestions(data || []);
          } catch (error) {
            setIntermediateSuggestions([]);
          } finally {
            setIsSearchingIntermediate(false);
          }
        } else {
          setIntermediateSuggestions([]);
        }
      }
    }, 600);
    return () => clearTimeout(delayDebounceFn);
  }, [formData.intermediateDestinations, activeIntermediateIndex]);

  const handleSelectOriginSuggestion = (suggestion) => {
    setFormData(prev => ({ 
      ...prev, 
      origin: suggestion.display_name, 
      originLat: suggestion.lat, 
      originLng: suggestion.lon 
    }));
    setFormErrors(prev => ({ ...prev, origin: false }));
    setOriginSuggestions([]);
  };

  const handleSelectDestinationSuggestion = (suggestion) => {
    setFormData(prev => ({ 
      ...prev, 
      destination: suggestion.display_name, 
      destinationLat: suggestion.lat, 
      destinationLng: suggestion.lon 
    }));
    setFormErrors(prev => ({ ...prev, destination: false }));
    setDestinationSuggestions([]);
  };

  const handleSelectIntermediateSuggestion = (suggestion, index) => {
    const newIntermediates = [...(formData.intermediateDestinations || [])];
    newIntermediates[index] = {
      ...newIntermediates[index],
      destination: suggestion.display_name,
      lat: suggestion.lat,
      lng: suggestion.lon
    };
    setFormData(prev => ({ ...prev, intermediateDestinations: newIntermediates }));
    setIntermediateSuggestions([]);
    setActiveIntermediateIndex(null);
  };

  // --- Container Management Local Functions ---
  const handleLocalContainerChange = (e, index) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newContainers = [...(prev.containers || [])];
      newContainers[index] = { ...newContainers[index], [name]: value };
      return { ...prev, containers: newContainers };
    });
    setFormErrors(prev => {
      const newContainersErrors = [...(prev.containers || [])];
      if (!newContainersErrors[index]) newContainersErrors[index] = {};
      newContainersErrors[index][name] = false;
      return { ...prev, containers: newContainersErrors };
    });
  };

  const handleInputWrapper = (e, field) => {
    if (field === 'origin') {
      setFormData(prev => ({ ...prev, origin: e.target.value, originLat: '', originLng: '' }));
    } else if (field === 'destination') {
      setFormData(prev => ({ ...prev, destination: e.target.value, destinationLat: '', destinationLng: '' }));
    } else {
      handleInputChange(e, field);
    }
    setFormErrors(prev => ({ ...prev, [field]: false }));
  };

  const addContainerRow = () => {
    setFormData(prev => ({
      ...prev,
      containers: [
        ...(prev.containers || []),
        { containerNumber: '', containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: '' }
      ]
    }));
  };

  const removeContainerRow = (index) => {
    setFormData(prev => ({
      ...prev,
      containers: prev.containers.filter((_, i) => i !== index)
    }));
  };

  // 30-40 Containers ek sath paste karne ke liye function
  const handleBulkAddContainers = () => {
    if (!bulkContainers.trim()) return;

    // Split by comma, space, or newline
    const numbers = bulkContainers.split(/[\n, ]+/).map(n => n.trim().toUpperCase()).filter(n => n);
    const validNumbers = [];
    const invalidNumbers = [];
    const containerRegex = /^[A-Z]{4}\d{7}$/;

    numbers.forEach(num => {
      if (containerRegex.test(num)) validNumbers.push(num);
      else invalidNumbers.push(num);
    });

    if (validNumbers.length > 0) {
      const newContainerObjs = validNumbers.map(num => ({
        containerNumber: num, containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: ''
      }));

      setFormData(prev => {
        let current = [...(prev.containers || [])];
        // Agar pehla container khali hai toh usko replace kardo
        if (current.length === 1 && !current[0].containerNumber) {
          current = newContainerObjs;
        } else {
          current = [...current, ...newContainerObjs];
        }
        return { ...prev, containers: current };
      });
      
      setBulkContainers('');
      toast.success(`${validNumbers.length} Containers bulk added!`, { position: "top-right" });
    }

    if (invalidNumbers.length > 0) {
      toast.warning(`Skipped invalid formats: ${invalidNumbers.join(', ')}`, { position: "top-right" });
    }
  };

  // Handle adding intermediate stops locally
  const addIntermediateStop = () => {
    setFormData({
      ...formData,
      intermediateDestinations: [
        ...(formData.intermediateDestinations || []), 
        { destination: '', time: '', lat: '', lng: '' }
      ],
    });
  };

  // Helper function to reset form
  const resetForm = () => {
    setFormData({
      orderId: '', sl: '', origin: '', destination: '', description: '', goodsType: '',
      pickUpDate: '', dropOffDate: '', pickUpHours: '', dropOffHours: '',
      length: '', commodity: '', terminal: '', routeNotes: '', vehicleNumber: '',
      addOnDate: '', estimateDeliveryDate: '', portName: '', ticketNumber: '', bookingNumber: '', price: '', status: '',
      contactNumber: '', countryCode: '+1',
      originLat: '', originLng: '', destinationLat: '', destinationLng: '',
      importExportType: formData.importExportType || 'import',
      containers: [{ containerNumber: '', containerType: '', sealNumber: '', weight: '', noOfPallets: '', containerComments: '' }],
      intermediateDestinations: [],
      totalNumberOfContainer: '',
      containerType: ''
    });
  };

  // ==========================================
  // VALIDATION LOGIC
  // ==========================================
  const validateForm = (data) => {
    let isValid = true;
    const errors = {};
    let firstErrorMsg = null;
    let firstErrorId = null;

    const requiredFields = [
      'orderId', 'sl', 'origin', 'destination', 
      'goodsType', 'pickUpDate', 'dropOffDate', 'addOnDate', 'estimateDeliveryDate', 'status',
      'terminal', 'routeNotes'
    ];

    for (const field of requiredFields) {
      if (!data[field]) {
        const msg = `${t('orders.' + field, field)} Required`;
        errors[field] = msg;
        isValid = false;
        if (!firstErrorMsg) firstErrorMsg = msg;
        if (!firstErrorId) firstErrorId = field;
      }
    }

    // --- Validate Containers or Total Count ---
    if (data.importExportType === 'export') {
      if (!data.totalNumberOfContainer || data.totalNumberOfContainer <= 0 || !Number.isInteger(Number(data.totalNumberOfContainer))) {
        isValid = false;
        if (!firstErrorMsg) firstErrorMsg = 'Total Number of Containers must be a positive whole number';
        if (!firstErrorId) firstErrorId = 'totalNumberOfContainer';
      }
      if (!data.containerType) {
        isValid = false;
        if (!firstErrorMsg) firstErrorMsg = 'Container Type is required for export';
        if (!firstErrorId) firstErrorId = 'containerTypeExport';
      }
    } else {
      if (!data.containers || data.containers.length === 0) {
        isValid = false;
        if (!firstErrorMsg) firstErrorMsg = `At least one container is required`;
      }

      errors.containers = [];
      const containerRegex = /^[A-Za-z]{4}\d{7}$/;
      if (data.containers) {
        for (let i = 0; i < data.containers.length; i++) {
          const containerNum = data.containers[i].containerNumber;
          if (!containerNum) {
            const msg = `Container Number required`;
            errors.containers[i] = { containerNumber: msg };
            isValid = false;
            if (!firstErrorMsg) firstErrorMsg = `Container Number required for Container #${i + 1}`;
            if (!firstErrorId) firstErrorId = `containerNumber-${i}`;
          } else if (!containerRegex.test(containerNum)) {
            const msg = `Format: 4 letters + 7 numbers`;
            errors.containers[i] = { containerNumber: msg };
            isValid = false;
            if (!firstErrorMsg) firstErrorMsg = `Invalid format for Container #${i + 1} (${containerNum}). Must be 4 letters + 7 numbers.`;
            if (!firstErrorId) firstErrorId = `containerNumber-${i}`;
          }
        }
      }
    }

    // --- Coordinates Validation ---
    const isValidLatitude = (val) => { const n = parseFloat(val); return !isNaN(n) && n >= -90 && n <= 90; };
    const isValidLongitude = (val) => { const n = parseFloat(val); return !isNaN(n) && n >= -180 && n <= 180; };

    if (!data.originLat || !data.originLng) {
      const msg = "Origin coordinates are required (Select on Map)";
      errors.origin = msg;
      isValid = false;
      if (!firstErrorMsg) firstErrorMsg = msg;
      if (!firstErrorId) firstErrorId = 'origin';
    } else if (!isValidLatitude(data.originLat) || !isValidLongitude(data.originLng)) {
      const msg = t('errors.invalidCoordinates', { field: 'Origin' });
      errors.origin = msg;
      isValid = false;
      if (!firstErrorMsg) firstErrorMsg = msg;
      if (!firstErrorId) firstErrorId = 'origin';
    }

    if (!data.destinationLat || !data.destinationLng) {
      const msg = "Destination coordinates are required (Select on Map)";
      errors.destination = msg;
      isValid = false;
      if (!firstErrorMsg) firstErrorMsg = msg;
      if (!firstErrorId) firstErrorId = 'destination';
    } else if (!isValidLatitude(data.destinationLat) || !isValidLongitude(data.destinationLng)) {
      const msg = t('errors.invalidCoordinates', { field: 'Destination' });
      errors.destination = msg;
      isValid = false;
      if (!firstErrorMsg) firstErrorMsg = msg;
      if (!firstErrorId) firstErrorId = 'destination';
    }

    setFormErrors(errors);

    if (!isValid) {
      if (firstErrorMsg) toast.error(firstErrorMsg, { position: "top-right" });
      if (firstErrorId) {
        setTimeout(() => {
          const el = document.getElementById(firstErrorId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus();
          }
        }, 100);
      }
    }

    return isValid;
  };

  // ==========================================
  // ADD TO LIST (QUEUE)
  // ==========================================
  const handleAddToList = () => {
    if (!validateForm(formData)) return;
    
    const validatedIntermediateDestinations = (formData.intermediateDestinations || []).map((stop, index) => {
      if (stop.destination === '' && stop.time === '' && formData.intermediateDestinations.length === 1) return null;
      if (!stop.destination || !stop.time) {
        toast.error(`Intermediate Stop ${index + 1} is incomplete`, { position: "top-right" });
        return false;
      }
      return stop;
    });

    if (validatedIntermediateDestinations.includes(false)) return;

    setShipmentQueue([...shipmentQueue, { ...formData }]);
    toast.success(`Shipment added to list!`, { position: "top-right" });
    resetForm();
  };

  const removeFromQueue = (index) => {
    const newQueue = [...shipmentQueue];
    newQueue.splice(index, 1);
    setShipmentQueue(newQueue);
  };

  // ==========================================
  // SUBMIT ALL API LOGIC
  // ==========================================
 const handleFinalSubmit = async (e) => {
    e.preventDefault();
    try {
      let finalQueue = [...shipmentQueue];
      
      // Agar form mein details bhari hain toh usko bhi list mein daal lo
      if (formData.orderId || formData.origin) {
        if (!validateForm(formData)) return;
        finalQueue.push({ ...formData });
      }

      if (finalQueue.length === 0) {
        toast.error("Please fill the details or add to list first!", { position: "top-right" });
        return;
      }

      setIsSubmitting(true);

      const addShipmentPromises = [];
      const containerDataToPost = []; 

      for (const shipmentData of finalQueue) {
        const selectedSlObj = shippingLines.find(line => (line._id || line.id || line.name || line) === shipmentData.sl);
        const shippingLineName = selectedSlObj ? (selectedSlObj.name || selectedSlObj) : shipmentData.sl;

        const validatedIntermediateDestinations = (shipmentData.intermediateDestinations || [])
          .filter(stop => stop.destination && stop.time)
          .map(stop => ({
            destination: stop.destination,
            time: stop.time,
            coordinates: (stop.lng && stop.lat) ? {
              type: 'Point',
              coordinates: [parseFloat(stop.lng), parseFloat(stop.lat)]
            } : undefined
          }));

        if (shipmentData.importExportType === 'export') {
          const submissionData = {
            ...shipmentData,
            totalNumberOfContainer: shipmentData.totalNumberOfContainer,
            containerType: shipmentData.containerType,
            
            currentLocation: (shipmentData.originLng && shipmentData.originLat) 
              ? { type: 'Point', coordinates: [parseFloat(shipmentData.originLng), parseFloat(shipmentData.originLat)] } 
              : undefined,
              
            destinationLocation: (shipmentData.destinationLng && shipmentData.destinationLat) 
              ? { type: 'Point', coordinates: [parseFloat(shipmentData.destinationLng), parseFloat(shipmentData.destinationLat)] } 
              : undefined,
              
            intermediateDestinations: validatedIntermediateDestinations.length > 0 ? validatedIntermediateDestinations : undefined,
            contactNumber: formData.contactNumber ? `${formData.countryCode || '+1'} ${formData.contactNumber}` : undefined,
            containers: undefined
          };

          const fieldsToRemoveIfEmpty = [
            'driverId', 'driverContactNumber', 'vehicleNumber', 'containerType', 'sealNumber', 'weight', 'noOfPallets', 'containerComments',
            'sl', 'terminal', 'routeNotes', 'length', 'commodity', 'portName', 'ticketNumber', 'bookingNumber', 'price'
          ];
          fieldsToRemoveIfEmpty.forEach(key => {
            if (submissionData[key] === null || submissionData[key] === undefined || submissionData[key] === '') {
              delete submissionData[key];
            }
          });

          addShipmentPromises.push(addShipment(submissionData));
        } else {
          // Loop through all containers in this shipment data and create an API request for each
          shipmentData.containers.forEach((container) => {
            const submissionData = {
              ...shipmentData,
              containerNumber: container.containerNumber ? container.containerNumber.toUpperCase() : "",
              containerType: container.containerType,
              sealNumber: container.sealNumber,
              weight: container.weight,
              noOfPallets: container.noOfPallets,
              containerComments: container.containerComments,
              
              currentLocation: (shipmentData.originLng && shipmentData.originLat) 
                ? { type: 'Point', coordinates: [parseFloat(shipmentData.originLng), parseFloat(shipmentData.originLat)] } 
                : undefined,
                
              destinationLocation: (shipmentData.destinationLng && shipmentData.destinationLat) 
                ? { type: 'Point', coordinates: [parseFloat(shipmentData.destinationLng), parseFloat(shipmentData.destinationLat)] } 
                : undefined,
                
              intermediateDestinations: validatedIntermediateDestinations.length > 0 ? validatedIntermediateDestinations : undefined,
              contactNumber: formData.contactNumber ? `${formData.countryCode || '+1'} ${formData.contactNumber}` : undefined,
              containers: undefined // Remove array from payload, sending single container details at root
            };

            const fieldsToRemoveIfEmpty = [
              'driverId', 'driverContactNumber', 'vehicleNumber', 'containerType', 'sealNumber', 'weight', 'noOfPallets', 'containerComments',
              'sl', 'terminal', 'routeNotes', 'length', 'commodity', 'portName', 'ticketNumber', 'bookingNumber', 'price'
            ];

            fieldsToRemoveIfEmpty.forEach(key => {
              if (submissionData[key] === null || submissionData[key] === undefined || submissionData[key] === '') {
                delete submissionData[key];
              }
            });

            // 1. Queue Main API
            addShipmentPromises.push(addShipment(submissionData));

            // 2. Queue Container Data
            if (container.containerNumber && shippingLineName) {
              containerDataToPost.push({
                containerNumber: container.containerNumber.toUpperCase() ,
                shippingLine: shippingLineName
              });
            }
          });
        }
      }

      // ------------------------------------------------------------------
      // STEP 1: PEHLE ADD HOGA (Main Shipment Creation)
      // ------------------------------------------------------------------
      const res = await Promise.all(addShipmentPromises);
      console.log('Main Shipment Response:', res); 

      const allSuccessful = res.every(response => response?.status === 200 || response?.status === 201);

      if (allSuccessful) {
        
        // ------------------------------------------------------------------
        // STEP 2: FIR POST HOGA (Container Post)
        // ------------------------------------------------------------------
        if (containerDataToPost.length > 0) {
          const postPromises = containerDataToPost.map(payload => 
            postContainerInfo(payload).catch(err => console.error("Container post failed:", err))
          );
          await Promise.all(postPromises);
        }
fetchShipments()
        toast.success(
          `Successfully created ${res.length} Container Shipment(s)!`, 
          { position: "top-right", autoClose: 5000 }
        );

        setShipmentQueue([]);
        resetForm();

        if (onSuccess) onSuccess();
        if (onClose) onClose(); 

      } else {
        toast.warning("Some shipments failed to create. Please check the console logs.", { position: "top-right" });
      }

    } catch (err) {
      toast.error(err.message || 'Failed to create shipment(s)', { position: "top-right" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div
        className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-full max-w-[1000px] max-h-[90vh] overflow-y-auto custom-scrollbar flex flex-col md:flex-row gap-6"
        style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-300 hover:text-white transition z-10"
        >
          <FiX />
        </button>

        {/* --- MAIN FORM SECTION (Left Side) --- */}
        <div className="flex-1">
          <h2 className="text-xl sm:text-2xl font-bold mb-6">
            {t('orders.createNewContainer')}
          </h2>

          {/* --- Tabs --- */}
          <div className="flex justify-center mb-6">
            <div className="bg-[#151b40] p-1 border border-[#2A2A4D] rounded-full flex w-full max-w-[450px] overflow-x-auto custom-scrollbar">
              <button
                type="button"
                onClick={() => {
                  setSelectedTab('Import');
                  setFormData({ ...formData, importExportType: 'import' });
                }}
                className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Import' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
              >
                {t('orders.import')}
              </button>
              <button
                type="button"
                onClick={() => {
                  setSelectedTab('Export');
                  setFormData({ ...formData, importExportType: 'export' });
                }}
                className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Export' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
              >
                {t('orders.export')}
              </button>
              {/* <button
                type="button"
                onClick={() => {
                  setSelectedTab('Dispatch');
                  setFormData({ ...formData, importExportType: 'Disptach' });
                }}
                className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'Dispatch' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
              >
                {t('Dispatch')}
              </button> */}
              <button
                type="button"
                onClick={openFTL}
                className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'FTL' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
              >
                {t('FTL')}
              </button>
              <button
                type="button"
                onClick={openLTL}
                className={`flex-1 py-1.5 px-3 rounded-full text-sm font-semibold transition whitespace-nowrap ${selectedTab === 'LTL' ? 'bg-white text-[#003057]' : 'bg-transparent text-[#6E7A90] hover:text-white'}`}
              >
                {t('LTL')}
              </button>
            </div>
          </div>

          {/* --- Form --- */}
          {selectedTab === 'Export' ? (
            <ExportBookingWizard onClose={onClose} onSuccess={onSuccess} />
          ) : (
            <form className="space-y-4" onSubmit={handleFinalSubmit}>
              
              {/* Order ID */}
              <div>
              <label className="text-sm block mb-1 text-gray-300">{selectedTab === 'Export' ? 'Booking Number' : t('orders.orderId')}</label>
              <input
                id="orderId"
                className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none focus:ring-2 focus:ring-[#6F1AFF] ${formErrors.orderId ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                value={formData.orderId}
                onChange={(e) => handleInputWrapper(e, 'orderId')}
                placeholder={selectedTab === 'Export' ? 'e.g., BOOK123456' : t('orders.orderIdPlaceholder')}
              />
              {formErrors.orderId && <p className="text-red-400 text-xs mt-1">{formErrors.orderId}</p>}
            </div>

            <h3 className="text-sm text-cyan-400 font-semibold mt-4 border-b border-[#2A2A4D] pb-1">
              {selectedTab === 'Export' ? 'Steamship Line' : t('orders.shippingLine')}
            </h3>
            
            <div>
              <label className="text-sm block mb-1 text-gray-300">{selectedTab === 'Export' ? 'Select Steamship Line' : t('orders.selectShippingLine')}</label>
              <select
                id="sl"
                className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.sl ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                value={formData.sl}
                onChange={(e) => handleInputWrapper(e, 'sl')}
              >
                <option value="">{t('orders.selectShippingLine')}</option>
                {shippingLines.map((line, index) => (
                  <option key={index} value={line._id || line.id || line.name || line}>
                    {line.name || line}
                  </option>
                ))}
              </select>
              {formErrors.sl && <p className="text-red-400 text-xs mt-1">{formErrors.sl}</p>}
            </div>

            {/* Locations */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="relative">
                <label className="text-sm block mb-1 text-gray-300">{selectedTab === 'Export' ? 'Port of Loading' : t('orders.origin')}</label>
                <div className="relative">
                  <input
                    id="origin"
                    className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none mb-2 ${formErrors.origin ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                    value={formData.origin}
                    onChange={(e) => handleInputWrapper(e, 'origin')}
                    placeholder={t('orders.originPlaceholder')}
                  />
                  {isSearchingOrigin && (
                    <div className="absolute right-3 top-2 w-4 h-4 border-2 border-t-[#6F1AFF] border-gray-300 rounded-full animate-spin"></div>
                  )}
                </div>
                {formErrors.origin && <p className="text-red-400 text-xs mb-2 -mt-1">{formErrors.origin}</p>}

                {/* Origin Suggestions */}
                {originSuggestions.length > 0 && (
                  <div className="absolute top-16 left-0 w-full mt-1 bg-white shadow-2xl rounded-md z-50 max-h-48 overflow-y-auto text-black border border-gray-200">
                    {originSuggestions.map((suggestion, index) => (
                      <div 
                        key={index} 
                        className="px-3 py-2 text-sm hover:bg-violet-50 cursor-pointer border-b last:border-b-0 border-gray-100 transition-colors"
                        onClick={() => handleSelectOriginSuggestion(suggestion)}
                      >
                        {suggestion.display_name}
                      </div>
                    ))}
                  </div>
                )}

                <button
                  type="button"
                  onClick={() => openMap('origin')}
                  className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90 transition"
                >
                  {t('orders.selectOnMap')}
                </button>
                {formData.originLat && formData.originLng && (
                  <div className="text-xs text-gray-400 mt-1">
                    {formData.originLat}, {formData.originLng}
                  </div>
                )}
              </div>
              
              <div className="relative">
                <label className="text-sm block mb-1 text-gray-300">{selectedTab === 'Export' ? 'Final Destination' : t('orders.destination')}</label>
                <div className="relative">
                  <input
                    id="destination"
                    className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none mb-2 ${formErrors.destination ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                    value={formData.destination}
                    onChange={(e) => handleInputWrapper(e, 'destination')}
                    placeholder={t('orders.destinationPlaceholder')}
                  />
                  {isSearchingDestination && (
                    <div className="absolute right-3 top-2 w-4 h-4 border-2 border-t-[#6F1AFF] border-gray-300 rounded-full animate-spin"></div>
                  )}
                </div>
                {formErrors.destination && <p className="text-red-400 text-xs mb-2 -mt-1">{formErrors.destination}</p>}

                {/* Destination Suggestions */}
                {destinationSuggestions.length > 0 && (
                  <div className="absolute top-16 left-0 w-full mt-1 bg-white shadow-2xl rounded-md z-50 max-h-48 overflow-y-auto text-black border border-gray-200">
                    {destinationSuggestions.map((suggestion, index) => (
                      <div 
                        key={index} 
                        className="px-3 py-2 text-sm hover:bg-violet-50 cursor-pointer border-b last:border-b-0 border-gray-100 transition-colors"
                        onClick={() => handleSelectDestinationSuggestion(suggestion)}
                      >
                        {suggestion.display_name}
                      </div>
                    ))}
                  </div>
                )}

                <button
                  type="button"
                  onClick={() => openMap('destination')}
                  className="w-full py-2 bg-[#6F1AFF] text-white rounded-md text-sm hover:opacity-90 transition"
                >
                  {t('orders.selectOnMap')}
                </button>
                {formData.destinationLat && formData.destinationLng && (
                  <div className="text-xs text-gray-400 mt-1">
                    {formData.destinationLat}, {formData.destinationLng}
                  </div>
                )}
              </div>
            </div>

            {/* Goods details */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.goodsDescription')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.description}
                  onChange={(e) => handleInputChange(e, 'description')}
                  placeholder={t('orders.goodsDescriptionPlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.goodsType')}</label>
                <select
                  id="goodsType"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.goodsType ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  value={formData.goodsType}
                  onChange={(e) => handleInputWrapper(e, 'goodsType')}
                >
                  <option value="">{t('orders.selectGoodsType', 'Select Goods Type')}</option>
                  <option value="Electronics">{t('orders.goodsTypeOptions.electronics', 'Electronics')}</option>
                  <option value="Machinery">{t('orders.goodsTypeOptions.machinery', 'Machinery')}</option>
                  <option value="Textiles">{t('orders.goodsTypeOptions.textiles', 'Textiles')}</option>
                  <option value="Other">{t('orders.goodsTypeOptions.other', 'Other')}</option>
                </select>
                {formErrors.goodsType && <p className="text-red-400 text-xs mt-1">{formErrors.goodsType}</p>}
              </div>
            </div>

            {/* Times */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.pickUpDateTime')}</label>
                <input
                  id="pickUpDate"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.pickUpDate ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  type="datetime-local"
                  value={formData.pickUpDate}
                  min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
                  onChange={(e) => handleInputWrapper(e, 'pickUpDate')}
                />
                {formErrors.pickUpDate && <p className="text-red-400 text-xs mt-1">{formErrors.pickUpDate}</p>}
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.dropOffDateTime')}</label>
                <input
                  id="dropOffDate"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.dropOffDate ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  type="datetime-local"
                  value={formData.dropOffDate}
                  min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
                  onChange={(e) => handleInputWrapper(e, 'dropOffDate')}
                />
                {formErrors.dropOffDate && <p className="text-red-400 text-xs mt-1">{formErrors.dropOffDate}</p>}
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.pickUpHours')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.pickUpHours}
                  onChange={(e) => handleInputChange(e, 'pickUpHours')}
                  placeholder={t('orders.pickUpHoursPlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.dropOffHours')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.dropOffHours}
                  onChange={(e) => handleInputChange(e, 'dropOffHours')}
                  placeholder={t('orders.dropOffHoursPlaceholder')}
                />
              </div>
            </div>

            {/* --- EXPORT: TOTAL CONTAINERS --- */}
            {selectedTab === 'Export' && (
              <div className="mt-6 border border-[#2A2A4D] rounded-lg p-4 bg-[#101533]">
                <h3 className="text-sm text-cyan-400 font-semibold mb-4">{t('orders.exportContainerDetails', 'Export Container Requirements')}</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs block mb-1 text-gray-400">Total Number of Containers*</label>
                    <input
                      id="totalNumberOfContainer"
                      name="totalNumberOfContainer"
                      type="number"
                      className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.totalNumberOfContainer ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                      value={formData.totalNumberOfContainer || ''}
                      onChange={(e) => handleInputWrapper(e, 'totalNumberOfContainer')}
                      placeholder="e.g. 29"
                      min={1}
                    />
                    {formErrors.totalNumberOfContainer && <p className="text-red-400 text-xs mt-1">{formErrors.totalNumberOfContainer}</p>}
                  </div>
                  <div>
                    <label className="text-xs block mb-1 text-gray-400">Container Type*</label>
                    <input
                      id="containerTypeExport"
                      name="containerType"
                      className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.containerTypeExport ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                      value={formData.containerType || ''}
                      onChange={(e) => handleInputWrapper(e, 'containerType')}
                      placeholder="e.g. 40HC"
                    />
                    {formErrors.containerTypeExport && <p className="text-red-400 text-xs mt-1">{formErrors.containerTypeExport}</p>}
                  </div>
                </div>
              </div>
            )}

            {/* --- MULTIPLE CONTAINER DETAILS SECTION (IMPORT) --- */}
            {selectedTab !== 'Export' && (
              <>
            <div className="flex justify-between items-end mt-6 border-b border-[#2A2A4D] pb-2">
              <h3 className="text-sm text-cyan-400 font-semibold">
                {t('orders.containerDetails')} ({formData.containers?.length || 0})
              </h3>
            </div>
                        {/* BULK ADD TEXTAREA (For 30-40 containers) */}
{selectedTab !== 'Export' && <div className="bg-[#101533] p-3 rounded-lg border border-cyan-800/50 mt-2">

       
              <label className="text-xs text-cyan-300 font-semibold mb-2 block flex items-center gap-2">
                <FiCopy /> Bulk Paste Container Numbers (Optional)
              </label>
              <div className="flex gap-2">
                <textarea
                  rows={2}
                  className="flex-1 px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  placeholder="Paste multiple container numbers here separated by comma or new line..."
                  value={bulkContainers}
                  onChange={(e) => setBulkContainers(e.target.value)}
                />
                <button
                  type="button"
                  onClick={handleBulkAddContainers}
                  className="bg-cyan-600 hover:bg-cyan-500 text-white px-4 py-2 rounded font-bold text-sm transition"
                >
                  Add Bulk
                </button>
              </div>
           </div>
}
            <div className="max-h-[300px] overflow-y-auto custom-scrollbar pr-2 mt-4 space-y-4">
              {(formData.containers || []).map((container, index) => (
                <div key={index} className="p-4 border border-[#2A2A4D] rounded-lg bg-[#101533] relative">
                  
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-xs font-bold text-gray-300 bg-[#1D2461] px-2 py-1 rounded">Container #{index + 1}</span>
                    {formData.containers.length > 1 && (
                      <button 
                        type="button" 
                        onClick={() => removeContainerRow(index)} 
                        className="text-red-400 hover:text-red-300 bg-red-400/10 p-1.5 rounded-full transition"
                      >
                        <FiTrash2 size={14}/>
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.containerNumber')}*</label>
                      <input
                        id={`containerNumber-${index}`}
                        name="containerNumber"
                        className={`w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none uppercase ${formErrors.containers?.[index]?.containerNumber ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                        value={container.containerNumber || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder="ABCD1234567"
                        maxLength={11}
                      />
                      {formErrors.containers?.[index]?.containerNumber && <p className="text-red-400 text-[10px] mt-1">{formErrors.containers[index].containerNumber}</p>}
                    </div>
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.containerType')}</label>
                      <input
                        name="containerType"
                        className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
                        value={container.containerType || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder={t('orders.containerTypePlaceholder')}
                      />
                    </div>
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.sealNumber')}</label>
                      <input
                        name="sealNumber"
                        className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
                        value={container.sealNumber || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder={t('orders.sealNumber')}
                      />
                    </div>
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.noOfPallets')}</label>
                      <input
                        name="noOfPallets"
                        type="number"
                        className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
                        value={container.noOfPallets || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder="0"
                      />
                    </div>
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.weight')}</label>
                      <input
                        name="weight"
                        type="number"
                        className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
                        value={container.weight || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder="0"
                      />
                    </div>
                    <div>
                      <label className="text-xs block mb-1 text-gray-400">{t('orders.containerComments')}</label>
                      <input
                        name="containerComments"
                        className="w-full px-2 py-1.5 rounded bg-white text-black text-sm outline-none"
                        value={container.containerComments || ''}
                        onChange={(e) => handleLocalContainerChange(e, index)}
                        placeholder="Any notes..."
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={addContainerRow}
              className="text-cyan-400 text-sm font-semibold hover:underline flex items-center gap-1 mt-2"
            >
              <FiPlusCircle /> Add Another Container
            </button>

              <div className="flex gap-3 text-[11px] sm:text-xs text-cyan-100 bg-cyan-900/30 p-3 rounded-lg border border-cyan-800/50 leading-relaxed mt-2">
                <FiInfo className="text-cyan-400 shrink-0 mt-0.5" size={16} />
                <p>
                  <span className="font-semibold text-cyan-400">ShipsGo Validation: </span> 
                  Validates container numbers (4 letters + 7 numbers) by integrating with carrier databases to provide real-time status.
                </p>
              </div>
              </>
            )}

            {/* Misc details */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.length')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.length}
                  onChange={(e) => handleInputChange(e, 'length')}
                  placeholder={t('orders.lengthPlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.commodity')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.commodity}
                  onChange={(e) => handleInputChange(e, 'commodity')}
                  placeholder={t('orders.commodityPlaceholder')}
                />
              </div>
            </div>

            {/* Route Info */}
            <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
              {t('orders.routeDeliveryInfo')}
            </h3>
            
            {(formData.intermediateDestinations || []).map((stop, index) => (
              <div key={index} className="space-y-2 border-l-2 border-[#6F1AFF] pl-4 mb-4 bg-[#101533] p-3 rounded-r-lg">
                <label className="text-sm block font-semibold text-cyan-300">
                  {t('orders.intermediateStop')} #{index + 1}
                </label>
                <div className="relative">
                  <input
                    className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                    value={stop.destination}
                    onFocus={() => setActiveIntermediateIndex(index)}
                    onChange={(e) => {
                      setActiveIntermediateIndex(index);
                      const newIntermediates = [...(formData.intermediateDestinations || [])];
                      newIntermediates[index] = { ...newIntermediates[index], destination: e.target.value, lat: '', lng: '' };
                      setFormData(prev => ({ ...prev, intermediateDestinations: newIntermediates }));
                    }}
                    placeholder={t('orders.intermediateStopPlaceholder')}
                  />
                  {activeIntermediateIndex === index && isSearchingIntermediate && (
                    <div className="absolute right-3 top-2 w-4 h-4 border-2 border-t-[#6F1AFF] border-gray-300 rounded-full animate-spin"></div>
                  )}
                  {activeIntermediateIndex === index && intermediateSuggestions.length > 0 && (
                    <div className="absolute top-full left-0 w-full mt-1 bg-white shadow-2xl rounded-md z-50 max-h-48 overflow-y-auto text-black border border-gray-200">
                      {intermediateSuggestions.map((suggestion, sIndex) => (
                        <div 
                          key={sIndex} 
                          className="px-3 py-2 text-sm hover:bg-violet-50 cursor-pointer border-b last:border-b-0 border-gray-100 transition-colors"
                          onClick={() => handleSelectIntermediateSuggestion(suggestion, index)}
                        >
                          {suggestion.display_name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  type="datetime-local"
                  value={stop.time}
                  onChange={(e) => handleInputChange(e, 'time', index)}
                />
                <button
                  type="button"
                  onClick={() => openMap('intermediate', index)}
                  className="w-full py-2 bg-[#1D2A85] text-white rounded-md text-sm hover:bg-[#2A3AA5] transition"
                >
                  {t('orders.selectOnMap')}
                </button>
                {stop.lat && stop.lng && (
                  <div className="text-xs text-gray-400 mt-1">
                    {stop.lat}, {stop.lng}
                  </div>
                )}
              </div>
            ))}
            <button
              type="button"
              onClick={addIntermediateStop}
              className="text-cyan-400 text-sm font-semibold hover:underline"
            >
              + {t('orders.addIntermediateStop')}
            </button>

            <div>
              <label className="text-sm block mb-1 text-gray-300">{t('orders.terminal')}</label>
              <input
                id="terminal"
                className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.terminal ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                value={formData.terminal}
                onChange={(e) => handleInputWrapper(e, 'terminal')}
                placeholder={t('orders.terminalPlaceholder')}
              />
              {formErrors.terminal && <p className="text-red-400 text-xs mt-1">{formErrors.terminal}</p>}
            </div>
            <div>
              <label className="text-sm block mb-1 text-gray-300">{t('orders.routeNotes')}</label>
              <textarea
                id="routeNotes"
                rows="3"
                className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.routeNotes ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                value={formData.routeNotes}
                onChange={(e) => handleInputWrapper(e, 'routeNotes')}
                placeholder={t('orders.routeNotesPlaceholder')}
              />
              {formErrors.routeNotes && <p className="text-red-400 text-xs mt-1">{formErrors.routeNotes}</p>}
            </div>

            {/* Other details (without driver selection) */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
              <div>
                <label className="text-sm block mb-1 text-gray-300">Contact Number</label>
                <div className="flex">
                  <select
                    className="px-2 py-2 rounded-l bg-white text-black text-sm outline-none border-r border-gray-300 w-24"
                    value={formData.countryCode}
                    onChange={(e) => handleInputChange(e, 'countryCode')}
                  >
                    <option value="+1">+1 (US/CA)</option>
                    <option value="+91">+91 (IN)</option>
                    <option value="+44">+44 (UK)</option>
                    <option value="+61">+61 (AU)</option>
                    <option value="+81">+81 (JP)</option>
                    <option value="+49">+49 (DE)</option>
                    <option value="+33">+33 (FR)</option>
                    <option value="+86">+86 (CN)</option>
                    <option value="+34">+34 (ES)</option>
                    <option value="+52">+52 (MX)</option>
                    <option value="+971">+971 (AE)</option>
                  </select>
                  <input
                    className="w-full px-3 py-2 rounded-r bg-white text-black text-sm outline-none"
                    value={formData.contactNumber}
                    onChange={(e) => handleInputChange(e, 'contactNumber')}
                    placeholder="Enter contact number"
                  />
                </div>
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.vehicleNumber')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.vehicleNumber}
                  onChange={(e) => handleInputChange(e, 'vehicleNumber')}
                  placeholder={t('orders.vehicleNumberPlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.addedOn')}</label>
                <input
                  id="addOnDate"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.addOnDate ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  type="datetime-local"
                  value={formData.addOnDate}
                  min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
                  onChange={(e) => handleInputWrapper(e, 'addOnDate')}
                />
                {formErrors.addOnDate && <p className="text-red-400 text-xs mt-1">{formErrors.addOnDate}</p>}
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.estimatedDeliveryDate')}</label>
                <input
                  id="estimateDeliveryDate"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.estimateDeliveryDate ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  type="datetime-local"
                  value={formData.estimateDeliveryDate}
                  min={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16)}
                  onChange={(e) => handleInputWrapper(e, 'estimateDeliveryDate')}
                />
                {formErrors.estimateDeliveryDate && <p className="text-red-400 text-xs mt-1">{formErrors.estimateDeliveryDate}</p>}
              </div>
            </div>

            {/* Port Details */}
            <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
              {t('orders.portDetails')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="relative">
                <label className="text-sm block mb-1 text-gray-300">{t('orders.portName')}</label>
                <div 
                  className="w-full px-3 py-2 rounded bg-white text-sm outline-none cursor-pointer flex justify-between items-center text-black"
                  onClick={() => setIsPortDropdownOpen(!isPortDropdownOpen)}
                >
                  <span className={formData.portName ? 'text-black font-semibold' : 'text-gray-400'}>
                    {formData.portName || t('orders.portNamePlaceholder')}
                  </span>
                  <span className="text-gray-500 text-[10px]">▼</span>
                </div>
                
                {isPortDropdownOpen && (
                  <div className="absolute top-full left-0 w-full mt-1 bg-white shadow-2xl rounded-md z-50 text-black border border-gray-200">
                    <div className="p-2 border-b border-gray-200 relative">
                      <input 
                        type="text"
                        autoFocus
                        className="w-full px-2 py-1.5 border border-gray-300 rounded outline-none text-sm"
                        placeholder="Search port..."
                        value={portSearchInput}
                        onChange={(e) => setPortSearchInput(e.target.value)}
                      />
                      {isSearchingPort && (
                        <div className="absolute right-4 top-4 w-4 h-4 border-2 border-t-[#6F1AFF] border-gray-300 rounded-full animate-spin"></div>
                      )}
                    </div>
                    <div className="max-h-48 overflow-y-auto custom-scrollbar">
                      {portSuggestions.length > 0 ? (
                        portSuggestions.map((suggestion, index) => (
                          <div 
                            key={index} 
                            className="px-3 py-2 text-sm hover:bg-violet-50 cursor-pointer border-b last:border-b-0 border-gray-100 transition-colors"
                            onClick={() => {
                              handleInputChange({ target: { value: suggestion.portName } }, 'portName');
                              setIsPortDropdownOpen(false);
                              setPortSearchInput('');
                              setPortSuggestions([]);
                            }}
                          >
                            <span className="font-semibold">{suggestion.portName}</span> <span className="text-gray-500 text-xs">({suggestion.portCode})</span>
                          </div>
                        ))
                      ) : (
                        <div className="px-3 py-2 text-sm text-gray-500 text-center">No ports found.</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.ticketNumber')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.ticketNumber}
                  onChange={(e) => handleInputChange(e, 'ticketNumber')}
                  placeholder={t('orders.ticketNumberPlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.bookingNumber')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  value={formData.bookingNumber}
                  onChange={(e) => handleInputChange(e, 'bookingNumber')}
                  placeholder={t('orders.bookingNumberPlaceholder')}
                />
              </div>
            </div>

            <h3 className="text-sm text-cyan-400 font-semibold mt-6 border-b border-[#2A2A4D] pb-1">
              {t('orders.pricelabel')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.price')}</label>
                <input
                  className="w-full px-3 py-2 rounded bg-white text-black text-sm outline-none"
                  type="number"
                  value={formData.price}
                  onChange={(e) => handleInputChange(e, 'price')}
                  placeholder={t('orders.pricePlaceholder')}
                />
              </div>
              <div>
                <label className="text-sm block mb-1 text-gray-300">{t('orders.statusLabel')}</label>
                <select
                  id="status"
                  className={`w-full px-3 py-2 rounded bg-white text-black text-sm outline-none ${formErrors.status ? 'border border-red-500 ring-2 ring-red-500' : ''}`}
                  value={formData.status}
                  onChange={(e) => handleInputWrapper(e, 'status')}
                >
                  <option value="">{t('orders.selectStatus')}</option>
                  <option value="Pending">{t('orders.status.pending')}</option>
                  <option value="In Transit">{t('orders.status.inTransit')}</option>
                  <option value="Delivered">{t('orders.status.delivered')}</option>
                </select>
                {formErrors.status && <p className="text-red-400 text-xs mt-1">{formErrors.status}</p>}
              </div>
            </div>

            {/* ACTION BUTTONS */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              
              {/* Button 1: Add to List & Clear Data */}
              <button
                type="button"
                onClick={handleAddToList}
                className="flex-1 py-3 border border-cyan-400 text-cyan-400 rounded-xl font-bold hover:bg-cyan-400/10 transition-all flex justify-center items-center gap-2"
              >
                <FiPlusCircle /> Add to List & New
              </button>

              {/* Button 2: Submit API Call */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex-1 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white py-3 rounded-xl font-bold hover:opacity-90 shadow-lg transition-all flex justify-center items-center"
              >
                {isSubmitting ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  shipmentQueue.length > 0 
                  ? `Submit All (${shipmentQueue.length} Batches)` 
                  : `Submit ${formData.containers?.length || 1} Container(s)`
                )}
              </button>
            </div>

          </form>
          )}
        </div>

        {/* --- QUEUE SIDEBAR (Right Side) --- */}
        {selectedTab !== 'Export' && shipmentQueue.length > 0 && (
          <div className="w-full md:w-[280px] bg-white/5 p-4 rounded-xl border border-white/10 h-fit sticky top-0">
            <h3 className="text-cyan-400 font-bold flex items-center gap-2 mb-4 border-b border-white/10 pb-2">
              <FiList /> Queued Shipments ({shipmentQueue.length})
            </h3>
            
            <div className="space-y-3 max-h-[400px] overflow-y-auto custom-scrollbar pr-1">
              {shipmentQueue.map((item, index) => (
                <div key={index} className="bg-[#101533] p-3 rounded-lg border border-[#2A2A4D] relative group hover:border-cyan-500 transition-colors">
                  <button 
                    onClick={() => removeFromQueue(index)}
                    className="absolute top-2 right-2 text-gray-500 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-opacity bg-[#101533] rounded-full p-1"
                  >
                    <FiTrash2 size={16} />
                  </button>
                  <p className="text-sm font-bold text-white flex items-center gap-1">
                    <FiCheckCircle className="text-green-400" size={14}/> {item.orderId || `Batch ${index + 1}`}
                  </p>
                  <div className="text-xs text-gray-400 mt-2 space-y-1">
                    <p><span className="text-gray-500">From:</span> {item.origin}</p>
                    <p><span className="text-gray-500">To:</span> {item.destination}</p>
                    <p><span className="text-gray-500">Containers:</span> {item.importExportType === 'export' ? `${item.totalNumberOfContainer} Total (Export)` : `${item.containers?.length || 0} Total`}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <p className="text-[11px] text-gray-400 mt-4 italic text-center">
              Click "Submit All" to create these shipments.
            </p>
          </div>
        )}

      </div>
    </div>
  );
}